import { render, staticRenderFns } from "./GDUsageStats.vue?vue&type=template&id=afa48808&scoped=true&"
import script from "./GDUsageStats.vue?vue&type=script&lang=js&"
export * from "./GDUsageStats.vue?vue&type=script&lang=js&"
import style0 from "./GDUsageStats.vue?vue&type=style&index=0&id=afa48808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa48808",
  null
  
)

export default component.exports